import { definePreset } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'
import { ganzimmunColors, primaryColorShades } from '@/theme/ganzimmunColors'
import { ganzimmunLightScheme } from '@/theme/ganzimmunLightScheme'
import { componentTheme } from '@/theme/componentTheming'

export const GanzimmunPreset = definePreset(Aura, {
  extend: {
    ganzimmun: ganzimmunColors
  },
  semantic: {
    primary: primaryColorShades,
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{ganzimmun.aquamarine}',
      offset: '2px'
    },
    colorScheme: {
      light: ganzimmunLightScheme
    }
  },
  components: componentTheme
})
